import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import DropdownOption from "../Components/DropdownOption.jsx";
import MemberRankingTable from "../Components/MemberRankingTable.jsx";
import PeriodOption from "../Components/PeriodOption.jsx";
import { ReactComponent as InfoMessage } from "../Images/info_message.svg";
import { ReactComponent as InfoRunning } from "../Images/info_running.svg";
import { ReactComponent as InfoShoe } from "../Images/info_shoe.svg";
import { ReactComponent as InfoStep } from "../Images/info_step.svg";
import { ReactComponent as BlueCircle } from "../Images/main_state_bluecircle.svg";
import Layout from "../Layout/Layout.jsx";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils.js";
import { useGoToAddr } from "../Utils/navigationUtils.js";
import { nation_to_cCode } from "../Utils/numberUtils.js";
import { getCompanyProfile } from "../Utils/sessionUtils.js";

const MainPageContent = () => {
  const navigate = useNavigate();
  const goToAddr = useGoToAddr();
  const { companyName } = getCompanyProfile();

  const [gifticon_list, setGifticon_list] = useState([]);
  const [ranking_list, setRanking_list] = useState([]);
  const [event_list, setEvent_list] = useState([]);
  const [QnA_list, setQnA_list] = useState([]);
  const [total_QnA, setTotal_QnA] = useState(0);
  const [waiting_QnA, setWaiting_QnA] = useState(0);
  const [period, setPeriod] = useState("day");
  const [nation, setNation] = useState("");

  const [todayStep, setTodayStep] = useState(0);
  const [curMonthStep, setCurMonthStep] = useState(0);
  const [prevMonthStep, setPrevMonthStep] = useState(0);
  const hasLoadedHomeWidgets = useRef(false);
  const lastRankingRequestKey = useRef(null);
  const nickname1 = "임직원임직원";
  const nickname2 = "임직원임직원임직원";
  const gifticons = [
    { id: 1, nickname: nickname1, date: "2024-04-03 24:04:00", num: 1 },
    { id: 2, nickname: nickname2, date: "2024-04-03 24:04:00", num: 2 },
    { id: 3, nickname: nickname2, date: "2024-04-03 24:04:00", num: 3 },
    { id: 4, nickname: nickname2, date: "2024-04-03 24:04:00", num: 4 },
    { id: 5, nickname: nickname2, date: "2024-04-03 24:04:00", num: 5 },
    { id: 6, nickname: nickname2, date: "2024-04-03 24:04:00", num: 6 },
    { id: 7, nickname: nickname1, date: "2024-04-03 24:04:00", num: 7 },
    { id: 8, nickname: nickname1, date: "2024-04-03 24:04:00", num: 8 },
  ];

  // const gifticons = [];
  const question_waiting = 2;

  const getGifticonList = async () => {
    try {
      const res = await postJson(
        "/dashboard/gifticonChallenge/getIssuedList",
        { page: 1, offset: 11 },
        navigate
      );
      if (res.code === 200) {
        setGifticon_list(res.data.rows);
      }
    } catch (error) {
      console.error("기프티콘 발급 현황 가져오기 중 에러:", error);
    }
  };

  const getRankingList = async () => {
    try {
      const body = {
        page: 1,
        offset: 12,
        period: period,
        cCode: nation_to_cCode(nation),
      };
      const data = await postJson("/dashboard/user/getRankingList", body, navigate);

      if (data.code === 200) {
        setRanking_list(data.data.rows);
      }
    } catch (error) {
      console.log("랭킹리스트 가져오기 중 에러:", error);
      throw error;
    }
  };

  const getEventList = async () => {
    try {
      const body = {
        page: 1,
        offset: 5,
      };

      const data = await postJson("/dashboard/event/getList", body, navigate);

      if (data.code === 200) {
        setEvent_list(data.data.rows);
      }
    } catch (error) {
      console.log("이벤트대회 리스트 가져오기 중 에러:", error);
      throw error;
    }
  };

  const getQnAList = async () => {
    try {
      const body = {
        page: 1,
        offset: 5,
      };
      const res = await postJson("/dashboard/qna/getList", body, navigate);

      if (res.code === 200) {
        setTotal_QnA(res.data.count);
        setWaiting_QnA(res.data.waitCount);
        setQnA_list(res.data.rows);
      }
    } catch (error) {
      console.log("문의 리스트 가져오기 중 에러");
      throw error;
    }
  };

  const getStepInfo = async () => {
    try {
      const res = await postJson("/dashboard/home/getStepInfo", {}, navigate);

      if (res.code === 200) {
        setTodayStep(res.data.todayStep);
        setCurMonthStep(res.data.curMonthStep);
        setPrevMonthStep(res.data.prevMonthStep);
      }
    } catch (error) {
      console.log("걸음수 가져오기 중 에러");
      throw error;
    }
  };

  useEffect(() => {
    if (hasLoadedHomeWidgets.current) {
      return;
    }

    hasLoadedHomeWidgets.current = true;
    getGifticonList();
    getEventList();
    getQnAList();
    getStepInfo();
  }, []);

  useEffect(() => {
    const requestKey = JSON.stringify({ period, nation });

    if (lastRankingRequestKey.current === requestKey) {
      return;
    }

    lastRankingRequestKey.current = requestKey;
    getRankingList();
  }, [period, nation]);

  return (
    <MainBox>
      {/* 상단 인사말 */}
      <h1>{companyName}님 반가워요!</h1>
      <br />
      <div className="textwrapper">
        <p>오늘은&nbsp;</p>
        <p style={{ color: "#1167ED" }}>
          {new Date().getFullYear()}년 {new Date().getMonth() + 1}월{" "}
          {new Date().getDate()}일&nbsp;
        </p>
        <p>입니다 ☺️</p>
      </div>

      {/* 걸음 수, 답변 대기 문의 등 정보 Bar */}
      <div className="infobar">
        <InfoBox
          title="오늘 누적 걸음 수"
          id={1}
          value={todayStep?.toLocaleString()}
        />
        <InfoBox
          title="이번달 누적 걸음 수"
          id={2}
          value={curMonthStep?.toLocaleString()}
        />
        <InfoBox
          title=" 지난달 누적 걸음 수"
          id={3}
          value={prevMonthStep?.toLocaleString()}
        />
        <InfoBox
          title="답변 대기 문의"
          id={4}
          value={waiting_QnA?.toLocaleString()}
        />
      </div>

      <StateArea>
        <div style={{ display: "flex" }}>
          {/* 기프티콘 발급 현황 */}
          <div className="gifticon area">
            <div className="title-btn-wrapper" style={{ width: "308px" }}>
              <p className="stateTitle">기프티콘 발급 현황</p>
              <p className="detailBtn" onClick={() => navigate("/challenge")}>
                자세히 보기
              </p>
            </div>

            {gifticon_list.length > 0 ? (
              <div className="gifticonbox">
                <div style={{ marginTop: "30px" }}>
                  {[...Array(11)].map((_, index) => (
                    <div key={`line-${index}`} style={{ marginTop: "-5px" }}>
                      <BlueCircle style={{ verticalAlign: "middle" }} />
                      {index !== 10 && <div className="blueline"></div>}
                    </div>
                  ))}
                </div>
                <div>
                  {gifticon_list.slice(0, 11).map((gifticon, index) => (
                    <GifticonComponent
                      key={`line-${index}`}
                      nickname={gifticon.nickName}
                      date={gifticon.regTime}
                      $isFirst={index === 0}
                    />
                  ))}
                </div>
              </div>
            ) : (
              <div className="gifticonbox center">
                <div
                  style={{
                    fontFamily: "notoSans-medium",
                    fontSize: "14px",
                    color: "#6d6d6d",
                  }}
                >
                  아직 내역이 없습니다.
                </div>
              </div>
            )}
          </div>
          {/* 실시간 랭킹 */}
          <div className="memberRanking area">
            <div className="title-btn-wrapper" style={{ width: "627px" }}>
              <p className="stateTitle">실시간 랭킹</p>
              <p className="detailBtn" onClick={() => goToAddr("member")}>
                전체보기
              </p>
            </div>
            <div
              style={{
                display: "flex",
                width: "630px",
                marginTop: "20px",
                marginLeft: "30px",
              }}
            >
              <PeriodOption optionChange={setPeriod} />

              <div style={{ marginLeft: "auto", marginRight: "-8px" }}>
                <DropdownOption
                  title="전체 국가"
                  dropdown_list={["대한민국", "미국", "대만", "일본", "중국"]}
                  optionChange={setNation}
                />
              </div>
            </div>

            <div style={{ marginLeft: "30px", marginTop: "10px" }}>
              <MemberRankingTable rankings={ranking_list} />
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* 이벤트 대회 관리 */}
          <div className="eventManage area">
            <div className="title-btn-wrapper" style={{ width: "382px" }}>
              <p className="stateTitle">이벤트 대회 관리</p>
              <p className="detailBtn" onClick={() => navigate("/event")}>
                전체보기
              </p>
            </div>

            <div className="eventManageBox">
              <div className="eventManage-label">
                <p className="leftalign">대회명</p>
                <p className="leftalign">대회 일정</p>
              </div>

              {event_list.length === 0 && (
                <div
                  className="center"
                  style={{
                    height: "280px",
                    color: "#6d6d6d",
                    fontFamily: "notoSans-medium",
                    fontSize: "14px",
                  }}
                >
                  등록한 대회가 없습니다.
                </div>
              )}
              {event_list.slice(0, 5).map((data) => (
                <EventManageComponent
                  key={data.seasonId}
                  title={data.title}
                  startTime={data.startTime}
                  endTime={data.endTime}
                />
              ))}
            </div>
          </div>
          {/* 문의 관리 */}
          <div className="questionManage area">
            <div className="title-btn-wrapper" style={{ width: "382px" }}>
              <p className="stateTitle">문의 관리</p>
              <p className="detailBtn" onClick={() => navigate("/qna")}>
                전체보기
              </p>
            </div>

            <div className="questionManageBox">
              <div className="questionManage-label">
                <p style={{ marginLeft: "14px" }}>
                  전체 문의 {total_QnA?.toLocaleString()}건 / 답변 대기&nbsp;
                </p>
                <p
                  style={
                    waiting_QnA === 0
                      ? { color: "#6d6d6d" }
                      : { color: "#F25C5C" }
                  }
                >
                  {waiting_QnA?.toLocaleString()}건
                </p>
              </div>
              {QnA_list.length === 0 && (
                <div
                  className="center"
                  style={{
                    height: "280px",
                    color: "#6d6d6d",
                    fontFamily: "notoSans-medium",
                    fontSize: "14px",
                  }}
                >
                  문의 내역이 없습니다.
                </div>
              )}
              {QnA_list.slice(0, 5).map((data) => (
                <QuestionManageComponent
                  key={data.qnaId}
                  content={data.content}
                  status={data.status}
                />
              ))}
            </div>
          </div>
        </div>
      </StateArea>
    </MainBox>
  );
};
const InfoBox = ({ title, id, value }) => {
  let unit = "걸음";
  if (id === 4) {
    unit = "건";
  }

  const icons = {
    1: <InfoStep />,
    2: <InfoShoe />,
    3: <InfoRunning />,
    4: <InfoMessage />,
  };

  return (
    <div className="infobox">
      <div className="info-wrapper">
        <p className="infotitle">{title}</p>
        <p className="data">
          {value}&nbsp;{unit}
        </p>
      </div>
      <div className="infoicon">{icons[id]}</div>
    </div>
  );
};

const GifticonComponent = ({ nickname, date, num, isFirst, isLast }) => {
  const len_nickname = nickname.length;
  return (
    <GifticonData
      num={num}
      $len_nickname={len_nickname}
      $isFirst={isFirst}
      isLast={isLast}
    >
      <div style={{ marginLeft: "10px", width: "282px" }}>
        <p className="message">{nickname}</p>
        <p className="date">{date}</p>
      </div>
    </GifticonData>
  );
};

const EventManageComponent = ({ title, startTime, endTime }) => {
  return (
    <EventManageData>
      <div className="scrollName leftalign">
        <p style={{ whiteSpace: "nowrap" }}>{title}</p>
      </div>
      <p className="leftalign">{startTime + " ~ " + endTime}</p>
    </EventManageData>
  );
};

const QuestionManageComponent = ({ content, status }) => {
  return (
    <QuestionManageData>
      <div className="scrollName leftalign">
        <p style={{ whiteSpace: "nowrap" }}>{content}</p>
      </div>
      <p
        className="leftalign"
        style={status === 0 ? { color: "#f25c5c" } : { color: "#1167ed" }}
      >
        {status === 0 ? "답변대기" : "답변완료"}
      </p>
    </QuestionManageData>
  );
};

const MainBox = styled.div`
  height: auto;
  > h1 {
    font-size: 32px;
    font-family: "notoSans-bold";
    margin-top: 30px;
    margin-left: 30px;
    margin-bottom: 0;
    color: #000000;
  }
  > div {
    margin-top: 30px;
    margin-left: 30px;
  }
  .textwrapper {
    display: flex;
    font-size: 32px;
    margin-top: -20px;
    > p {
      margin: 0;
      font-size: 32px;
      font-family: "notoSans-bold";
    }
  }
  .infobar {
    display: flex;
    width: 1590px;
  }
  .gifticonbox {
    width: 308px;
    height: 796px;
    display: flex;
    margin-left: 30px;
  }
  .blueline {
    border-left: 1px solid #1167ed;
    height: 57px;
    margin-top: -1px;
    margin-left: 7.5px;
  }
  .nationOption {
    width: 140px;
    height: 44px;
    border-radius: 8px;
    box-shadow: 0 0 0 1px #e4e4e4;
    background-color: #ffffff;
    margin-left: auto;
    font-family: "notoSans-medium";
    font-size: 14px;
    color: #222222;
    display: flex;
    align-items: center;
  }
  .eventManageBox {
    width: 382px;
    height: 330px;
    margin-left: 30px;
    margin-top: 20px;
  }
  .eventManage-label {
    display: grid;
    grid-template-columns: 178px 204px;
    height: 50px;
    background-color: #f5f5f5;
    font-family: "notoSans-medium";
    font-size: 16px;
    color: #6d6d6d;
  }
  .questionManageBox {
    width: 382px;
    height: 330px;
    margin-left: 30px;
    margin-top: 20px;
  }
  .questionManage-label {
    display: flex;
    align-items: center;
    width: 382px;
    height: 50px;
    background-color: #f5f5f5;
    font-family: "notoSans-medium";
    font-size: 16px;
    color: #6d6d6d;
  }
`;

const StateArea = styled.div`
  display: flex;
  .area {
    border-radius: 20px;
    background-color: #ffffff;
    box-shadow: 0 0 20px 0 #f2f2f2;
    margin-bottom: 30px;
    margin-right: 30px;
  }
  .gifticon {
    width: 368px;
    height: 911px;
  }
  .memberRanking {
    width: 690px;
    height: 911px;
  }
  .eventManage {
    width: 442px;
    height: 436px;
  }
  .questionManage {
    width: 442px;
    height: 445px;
  }
  .stateTitle {
    font-family: "notoSans-bold";
    font-size: 18px;
    color: #000000;
    margin: 0;
  }
  .detailBtn {
    font-family: "notoSans-medium";
    font-size: 16px;
    color: #6d6d6d;
    margin-left: auto;
    cursor: pointer;
  }
  .title-btn-wrapper {
    height: 26px;
    display: flex;
    align-items: center;
    margin-left: 30px;
    margin-top: 30px;
  }
`;

const GifticonData = styled.div`
  margin-top: 24px;
  .message {
    font-family: "notoSans";
    font-size: 16px;
    color: #000000;
    margin: 0;
  }
  .date {
    font-family: "notoSans-medium";
    font-size: 14px;
    color: #6d6d6d;
    margin: 0;
    margin-top: 7px;
  }
`;

const EventManageData = styled.div`
  display: grid;
  grid-template-columns: 174px 208px;
  height: 56px;
  box-shadow: inset 0 -1px 0 0 #e4e4e4;
  font-family: "notoSans";
  font-size: 16px;
  color: #000000;
  &:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`;

const QuestionManageData = styled.div`
  display: grid;
  grid-template-columns: 282px 100px;
  height: 56px;
  box-shadow: inset 0 -1px 0 0 #e4e4e4;
  font-family: "notoSans";
  font-size: 16px;
  color: #000000;
  &:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`;

const MainPage = () => {
  return <Layout page={<MainPageContent />} />;
};

export default MainPage;
